import { render } from "./RequestQuick.vue?vue&type=template&id=19e9698b&scoped=true&ts=true"
import script from "./RequestQuick.vue?vue&type=script&lang=ts"
export * from "./RequestQuick.vue?vue&type=script&lang=ts"

import "./RequestQuick.vue?vue&type=style&index=0&id=19e9698b&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e9698b"]])

export default __exports__